module.exports = __webpack_public_path__ + "static/media/wssp-bg-green.75db6676.svg";